// components/Footer/Footer.jsx
import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { socialLinks } from "../../data/socialLinks";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-logo-wrapper">
        <img
          src="/images/tutorslinks.png"
          alt="Tutorlinks Logo"
          className="footer-main-logo"
        />
      </div>

      {/* Main Footer Top Section */}
      <div className="footer-top">
        <div className="footer-container">
          {/* <div className="footer-left">
            <h2>Join Our Community</h2>
            <p>
              Stay ahead of the curve with exclusive updates and unbeatable
              offers from Tutorslinks. Subscribe now to be the first to discover
              the latest news from Tutorslinks.
            </p>

            <form className="newsletter-form">
              <input type="email" placeholder="Your Email" required />
              <button type="submit">Subscribe</button>
            </form>
          </div> */}

          <div className="footer-right">
            {/* <h3>Follow Us</h3> */}
            <div className="social-links">
              <a
                href="https://www.facebook.com/tutorslinks1"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon facebook"
                aria-label="Facebook"
              >
                <img src="/images/facebook-logo.png" alt="Facebook" />
              </a>

              <a
                href="https://x.com/TutorsLinks"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon twitter"
                aria-label="X (Twitter)"
              >
                <img src="/images/x.png" alt="X" />
              </a>

              <a
                href="https://www.instagram.com/tutorslinks/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon instagram"
                aria-label="Instagram"
              >
                <img src="/images/instagram.png" alt="Instagram" />
              </a>

              <a
                href="https://www.tiktok.com/@tutorslinks"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon tiktok"
                aria-label="TikTok"
              >
                <img src="/images/tiktok.png" alt="TikTok" />
              </a>

              <a
                href="https://www.youtube.com/@TutorsLinks"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon youtube"
                aria-label="YouTube"
              >
                <img src="/images/youtube.png" alt="YouTube" />
              </a>
            </div>

            {/* <div className="social-links">
  {socialLinks.map((social) => (
    <a
      key={social.name}
      href={social.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`footer-social-icon ${social.className}`}
      aria-label={social.name}
    >
      <img src={social.icon} alt={social.name} />
    </a>
  ))}
</div> */}
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <nav className="footer-links" aria-label="Footer Navigation">
            {/* <a href="/#testimonials">Testimonials</a> */}
            {/* <a href="/#faq">FAQs</a> */}

            {/* Page routes */}
            <NavLink to="/create-account?role=tutor">Become a Tutor/Centre</NavLink>

            <NavLink to="/create-account?role=institution">
              Register Training Centre
            </NavLink>

            <NavLink to="/about-us">About Us</NavLink>
            <NavLink to="/get-help">Contact Us</NavLink>
            <NavLink to="/blog">Blog</NavLink>
            <NavLink to="/code-of-conduct">Code of Conduct</NavLink>
            <NavLink to="/child-protection-policy">Child Protection</NavLink>
            <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
            <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            <NavLink to="/refund-cancellation-policy">Refund Policy</NavLink>
          </nav>
          <p>
            &copy; {currentYear} TutorsLinks By Efiko. All Rights Reserved |
            Copyright &copy; {currentYear}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
